// Utilitaire pour extraire les frais Amazon depuis la réponse SP-API ou custom
export function extractAmazonFees(feesEstimate) {
  let fba = 0, referral = 0;
  // Cas Amazon API classique
  if (feesEstimate?.FeeDetailList) {
    for (const fee of feesEstimate.FeeDetailList) {
      if (fee.FeeType === 'FBAFees') fba = fee.FeeAmount.Amount;
      if (fee.FeeType === 'ReferralFee') referral = fee.FeeAmount.Amount;
    }
  } else if (feesEstimate) {
    // Cas API custom (ta réponse)
    fba = feesEstimate.FBAFees || 0;
    referral = feesEstimate.ReferralFee || 0;
  }
  const digital = 0.03 * fba + 0.03 * referral;
  // Utilise TotalFeesEstimate si dispo, sinon somme manuelle
  let total = 0;
  if (feesEstimate?.TotalFeesEstimate?.Amount) {
    total = feesEstimate.TotalFeesEstimate.Amount;
  } else {
    total = fba + referral + digital;
  }
  return {
    FBAFees: fba,
    ReferralFees: referral,
    DigitalFees: digital,
    Total: total
  };
} 